import gql from "graphql-tag";

export const GET_ICONS_HOMEPAGE = gql`
    query heroIcons {
        heroIcons {
            homePage {
                items {
                    id
                    thumbnails {
                        thumbnail84
                    }
                    title
                    url
                }
                totalCount
            }
        }
    }
`;

export const GET_ICONS_ICONSPAGE = gql`
    query heroIcons {
        heroIcons {
            iconLandingPage {
                items {
                    id
                    thumbnails {
                        thumbnail84
                    }
                    title
                    url
                }
                totalCount
            }
        }
    }
`;
